import { render, staticRenderFns } from "./crudITDeclarations.vue?vue&type=template&id=2312d380&scoped=true"
import script from "./crudITDeclarations.vue?vue&type=script&lang=js"
export * from "./crudITDeclarations.vue?vue&type=script&lang=js"
import style0 from "./crudITDeclarations.vue?vue&type=style&index=0&id=2312d380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2312d380",
  null
  
)

export default component.exports